<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Font Awesome Pro</h1>
					<p waBody="m" waText>Font Awesome Pro 7.2.0 &mdash; 10,000+ premium icons across Regular, Light, Duotone, and Thin styles extending the community Font Awesome plugin. Requires an active Font Awesome Pro subscription.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Font Awesome Pro 7.2.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
						<wa-tag pill variant="warning">License Required</wa-tag>
					</div>
					<p waBody="s" waColorText="warning" waText>Font Awesome Pro requires an active subscription. Get your license at fontawesome.com/plans</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fontawesome-pro</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fontawesome5pro</p>
					<p waBody="s" waText>Built on: Font Awesome Pro 7.2.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_576" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_577" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_578" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;6&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesomeDuotone</h4>
								<p waBody="s" waColorText="quiet" waText>Duotone icon component &mdash; renders a fa-duotone-icon Angular element, extends FontAwesome with two-layer rendering and primary/secondary color support</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="neutral">2 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome-pro/font-awesome-duotone']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesome5ProStyles</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of Pro-exclusive icon styles &mdash; additional style variants available with a Pro license</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome-pro/font-awesome5pro-styles']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesome5Families</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of Pro+ icon families &mdash; decorative and specialty font families available with Pro+ subscription</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">10 props</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome-pro/font-awesome5families']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>IconFamily</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of all icon families for dependency management &mdash; used with FontAwesome5ProPageConfigurator.enableFamily&#40;&#41; to selectively install npm packages</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">22 props</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome-pro/icon-family']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesome5ProIcons</h4>
								<p waBody="s" waColorText="quiet" waText>Enum of 4,085 Pro icons &mdash; the full Pro icon set including all icons not available in the free tier</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">10 props</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome-pro/font-awesome5pro-icons']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FontAwesome5ProPageConfigurator</h4>
								<p waBody="s" waColorText="quiet" waText>Page configurator &mdash; manages Pro/Pro+ icon family npm dependencies and Kit-based cloud delivery</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">3 props</wa-tag>
									<wa-tag pill variant="neutral">7 methods</wa-tag>
									<wa-tag pill variant="success">3 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fontawesome-pro/font-awesome5pro-page-configurator']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (12)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>10,000+ premium icons &mdash; complete Font Awesome Pro library</p>
						<p waBody="s" waColorText="quiet" waText>Pro-exclusive styles &mdash; Regular, Light, Duotone, Thin</p>
						<p waBody="s" waColorText="quiet" waText>Extends Font Awesome Free &mdash; Solid and Brand styles included</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe Java enum API with compile-time safety</p>
						<p waBody="s" waColorText="quiet" waText>SVG or Web Font rendering</p>
						<p waBody="s" waColorText="quiet" waText>Icon transformations &mdash; rotate, flip, scale, position</p>
						<p waBody="s" waColorText="quiet" waText>Layering and masking &mdash; combine multiple icons</p>
						<p waBody="s" waColorText="quiet" waText>Animation effects &mdash; spin, pulse, custom animations</p>
						<p waBody="s" waColorText="quiet" waText>Sizing from xs to 10x</p>
						<p waBody="s" waColorText="quiet" waText>Angular FontAwesome module integration</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for icon configuration</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Pro Icon Styles</h4>
							<p waBody="s" waColorText="quiet" waText>Use the extended Pro icon styles &mdash; Regular, Light, Duotone, and Thin.</p>
							<markdown [data]="mdContent_579" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_580" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>FontAwesomeProPageConfigurator registers Pro icon packs &mdash; Regular, Light, Duotone, Thin SVG icons</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
						<wa-tag pill variant="neutral">Font Awesome Pro License</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fontawesome.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fontawesome.com/docs</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FontAwesomePro</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>